export default "__VITE_ASSET__DgPNllYQ__"